import React, { Component, Fragment } from 'react'
import { Avatar, Button, TextField, Grid, CircularProgress, IconButton} from 'material-ui'
import Dialog, { DialogActions, DialogContent, DialogTitle} from 'material-ui/Dialog'
import { FormControl } from 'material-ui/Form'
import Input, { InputLabel, InputAdornment } from 'material-ui/Input'
import { withStyles } from 'material-ui/styles'
import { FileUpload } from '@material-ui/icons'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import ReactCrop from 'react-image-crop'
import axios from 'axios'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
});

class RegisterDialog extends Component {
  state = {
    keepLogged: true,
    loading: false,
    username: "",
    imagePreviewUrl: "https://mrgames-server.de/chatlet_masterserver//web/media/favicon.png"
  }

  handleBackClick = () => {
    this.props.onBack();
  }

  handleRegisterClick = () => {
    if(!this.state.loading) {
      this.setState({
        loading: true,
        logged: true
      });
      this.register();
    }
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleClickShowPasswordRepeat = () => {
    this.setState({ showPasswordRepeat: !this.state.showPasswordRepeat });
  };

  handleFile(e) {
    e.preventDefault();

    let file = e.target.files[0];
    if(file.type === "image/png") {
      let reader = new FileReader();

      reader.onloadend = () => {
        this.setState({
          file: file,
          imagePreviewUrl: reader.result
        });
      }

      reader.readAsDataURL(file)
    } else {
      this.props.onAlertOpen("Ungültiger Dateityp", "Die Datei besitzt einen ungültigen Dateitypen! Bitte Datei vom Typ 'Portable Network Graphics' (PNG) hochladen.");
    }
  }

  register() {

  }

  render() {
    const { loading, open, imagePreviewUrl } = this.state;
    const { classes } = this.props;

    return <Fragment>
      <Dialog open={this.props.open} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title" color="primary">Chatlet Web - Account erstellen</DialogTitle>
        <DialogContent>
          <form autoComplete="off">
            <TextField autoFocus disabled={loading} id="username" label="Benutzername" style={{width: 280}} />
            <br/>
            <FormControl style={{marginTop: 10}}>
              <InputLabel htmlFor="password">Passwort</InputLabel>
              <Input id="password" disabled={loading} type={this.state.showPassword ? 'text' : 'password'} style={{width: 280}}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="Sichtbarkeit umschalten" disabled={loading} onClick={this.handleClickShowPassword} onMouseDown={this.handleMouseDownPassword} >
                      {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <br/>
            <FormControl style={{marginTop: 10}}>
              <InputLabel htmlFor="password_repeat">Passwort best&auml;tigen</InputLabel>
              <Input id="password_repeat" disabled={loading} type={this.state.showPasswordRepeat ? 'text' : 'password'} style={{width: 280}}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="Sichtbarkeit umschalten" disabled={loading} onClick={this.handleClickShowPasswordRepeat} onMouseDown={this.handleMouseDownPassword} >
                      {this.state.showPasswordRepeat ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <br/>
            <TextField id="status" label="Dein erster Status" disabled={loading} multiline rows="4" margin="normal" style={{width: 280}}/>
            <br/>
            <Grid container>
              <Grid item md="4">
                <Avatar alt="Ausgew&auml;hltes Profilbild" src={imagePreviewUrl} style={{width:50, height: 50}} />
              </Grid>
              <Grid item md="8">
                <input accept="image/png" id="raised-button-file" type="file" onChange={(e)=>this.handleFile(e)} style={{display: 'none'}} />
                <label htmlFor="raised-button-file">
                <Button variant="raised" disabled={loading} component="span" style={{marginTop: 4}}>
                  <FileUpload className={classes.leftIcon} />
                  Bild hochladen
                </Button>
                </label>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button color="primary" disabled={loading} onClick={this.handleBackClick}>Zur&uuml;ck</Button>
          <div className="classes.wrapper">
            <Button variant="raised" color="primary" disabled={loading} onClick={this.handleRegisterClick}>
              Account erstellen
              {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </Fragment>
  }
}

export default withStyles(styles)(RegisterDialog)



// WEBPACK FOOTER //
// ./src/Components/Dialogs/DialogRegister.js